import { useState } from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'
import getEvenOddByIndex from '../../../functions/getEvenOddByIndex'
import SearchInput from '../../general/SearchInput'
import TmdbExternalLink from '../../general/TmdbExternalLink'
import CinemaBadgeList from '../../general/CinemaBadgeList'
import SaveStateButton from '../../general/SaveStateButton'
import sortCinemas from '../../../functions/sortCinemas'

const FILTER_ALL = 'all'
const FILTER_LINKED = 'linked'
const FILTER_OPEN = 'open'

const PageTmdbPage = ({ movies, movieMappings, tmdbMovies, cinemas, clientCinemaId, onNavigate, goBackPath, programStatus, onUpdateProgram }) => {
    const [filter, setFilter] = useState(FILTER_ALL)
    const [searchQuery, setSearchQuery] = useState('')

    const allMovieIds = movies ? Object.keys(movies) : []
    const allCinemaIds = sortCinemas(clientCinemaId, cinemas) || []
    const totalCount = allMovieIds.length
    const linkedCount = allMovieIds.filter(id => movieMappings && movieMappings[id] && movieMappings[id].tmdb).length
    const openCount = totalCount - linkedCount

    const filteredIds = allMovieIds
        .filter(id => {
            const isLinked = movieMappings && movieMappings[id] && movieMappings[id].tmdb
            if (filter === FILTER_LINKED && !isLinked) return false
            if (filter === FILTER_OPEN && isLinked) return false
            const searchTitle = movies[id].titleDisplay || movies[id].title || ''
            if (searchQuery && !searchTitle.toLowerCase().includes(searchQuery.toLowerCase())) return false
            return true
        })
        .sort((a, b) => {
            const titleA = (movies[a].titleDisplay || movies[a].title || '').toLowerCase()
            const titleB = (movies[b].titleDisplay || movies[b].title || '').toLowerCase()
            return titleA.localeCompare(titleB)
        })

    const filterOptions = [
        { key: FILTER_ALL, label: <Translation id="alle_button" /> },
        { key: FILTER_LINKED, label: <Translation id="linked" /> },
        { key: FILTER_OPEN, label: <Translation id="open" /> },
    ]

    return (
        <WrapperPageSimple pageTitle="TMDB" closePagePath={goBackPath}>
            <div className="tmdb-list-page">
                <div className="db-stat-strip tmdb-stat-strip">
                    <div className="db-stat-card">
                        <div className="db-sc-val">{totalCount}</div>
                        <div className="db-sc-lbl text-xsmall-light"><Translation id="stat_total" /></div>
                    </div>
                    <div className="db-stat-card db-stat-card--accent">
                        <div className="db-sc-val">{linkedCount}</div>
                        <div className="db-sc-lbl text-xsmall-light"><Translation id="linked" /></div>
                    </div>
                    <div className="db-stat-card">
                        <div className="db-sc-val">{openCount}</div>
                        <div className="db-sc-lbl text-xsmall-light"><Translation id="open" /></div>
                    </div>
                </div>

                <div className="tmdb-toolbar">
                    <div className="tmdb-filter-pills">
                        {filterOptions.map(({ key, label }) => (
                            <button
                                key={key}
                                className={'tmdb-filter-pill text-small-regular' + (filter === key ? ' active' : '')}
                                onClick={() => setFilter(key)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    <SearchInput
                        placeholderTransId="social_media_search_movie_placeholder"
                        value={searchQuery}
                        onChange={setSearchQuery}
                        width={300}
                    />
                </div>

                <div className="tmdb-list-header text-light-uppercase">
                    <div className="tmdb-col-film"><Translation id="print_flyer_movie" /></div>
                    <div className="tmdb-col-tmdb"><Translation id="tmdb_label" /></div>
                    <div className="tmdb-col-status"><Translation id="col_status" /></div>
                    <div className="tmdb-col-action"><Translation id="list_filter_action" /></div>
                </div>

                <ul className="list-main">
                    {filteredIds.map((id, index) => {
                        const movie = movies[id]
                        const mapping = movieMappings && movieMappings[id]
                        const tmdbUuid = mapping && mapping.tmdb
                        const isLinked = !!tmdbUuid
                        const tmdbMovie = tmdbUuid && tmdbMovies && tmdbMovies[tmdbUuid]
                        const tmdbNumericId = tmdbMovie && tmdbMovie.tmdb_id

                        const hasPreview = !!(mapping && mapping.preview)

                        return (
                            <li key={id} className={'list-item ' + getEvenOddByIndex(index) + (isLinked ? ' tmdb-list-row--linked' : '')}>
                                <div className="tmdb-list-row">
                                    <div className="tmdb-col-film">
                                        <div className="tmdb-movie-title">
                                            {movie.titleDisplay || movie.title}
                                            {hasPreview && <span className="meta-mapping-pill meta-mapping-pill--preview text-small-light"><Translation id="button_preview" /></span>}
                                        </div>
                                        <div className="tmdb-cinema-badges">
                                            <CinemaBadgeList
                                                resolvedCinemaIds={movie.cinemaIds || []}
                                                allCinemaIds={allCinemaIds}
                                                cinemas={cinemas}
                                            />
                                        </div>
                                    </div>
                                    <div className="tmdb-col-tmdb">
                                        {isLinked && tmdbNumericId ? (
                                            <TmdbExternalLink tmdbId={tmdbNumericId} className="tmdb-external-link text-small-light" />
                                        ) : '—'}
                                    </div>
                                    <div className="tmdb-col-status">
                                        {isLinked ? (
                                            <span className="tmdb-status-badge tmdb-status-badge--linked text-small-regular">
                                                <span className="tmdb-status-dot" />
                                                <Translation id="linked" />
                                            </span>
                                        ) : (
                                            <span className="tmdb-status-badge tmdb-status-badge--unlinked text-small-regular">
                                                <div className="check-indicator has-no-content" />
                                                <Translation id="not_linked" />
                                            </span>
                                        )}
                                    </div>
                                    <div className="tmdb-col-action">
                                        <button
                                            className="tmdb-action-btn text-small-regular"
                                            onClick={() => onNavigate(`/tmdb/${id}?from=tmdblist`)}
                                        >
                                            {isLinked ? <Translation id="edit_button" /> : <Translation id="link_tmdb_button" />}
                                        </button>
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>

                <div className="save-program-button">
                    <SaveStateButton
                        status={programStatus}
                        transId="publish_program_button"
                        condition={true}
                        saveState={onUpdateProgram}
                    />
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default PageTmdbPage
